import { Stack, Typography } from '@mui/material';
import { RadioButtonGroup, WysiwygInput } from 'framework/form';
import { CreateEditFormDrawer } from 'framework/ViewTypes/contentLayout';
import type { CreateEditFormSection } from 'framework/ViewTypes/contentLayout';

type ApplicationChecklistReviewDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  applicationId: number;
};

const FULL_ROW_SIZE = { xs: 12, md: 12, xl: 12 };

const CHECKLIST_REVIEW_SECTIONS: CreateEditFormSection[] = [
  {
    id: 'feedback',
    title: 'Feedback *',
    fields: [
      {
        id: 'feedback',
        size: FULL_ROW_SIZE,
        content: <WysiwygInput source="feedback" label="" isRequired />,
      },
    ],
  },
  {
    id: 'meetsRequirements',
    fields: [
      {
        id: 'meetsRequirements',
        size: FULL_ROW_SIZE,
        content: (
          <Stack gap={3.75}>
            <Typography variant="body1">
              Indicate <strong>if the candidate meets the requirements</strong> based on the completed screening
              checklist
            </Typography>
            <RadioButtonGroup
              source="meetsRequirements"
              label=""
              options={[
                { value: 'YES', label: 'Yes' },
                { value: 'NO', label: 'No' },
              ]}
            />
          </Stack>
        ),
      },
    ],
  },
];

const ApplicationChecklistReviewDrawer = ({
  isOpen,
  onClose,
  applicationId,
}: ApplicationChecklistReviewDrawerProps) => (
  <CreateEditFormDrawer
    isOpen={isOpen}
    onClose={onClose}
    title="Review screening checklist"
    initialData={{ meetsRequirements: 'YES' }}
    isCreateRequest
    submitFormFunc={async () => {}}
    afterSubmit={{ execute: onClose, message: 'Screening checklist reviewed.' }}
    submitButtonTitle="Submit"
    handleDirty={false}
    getSections={() => CHECKLIST_REVIEW_SECTIONS}
  />
);

export default ApplicationChecklistReviewDrawer;
